module.exports = __webpack_public_path__ + "img/carret-down.ba021a89.svg";